import apiV2 from '.'

export const typoApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    getTypos: builder.query({
      query: ({ domainId, eventId, byEvent }) => `/domains/${domainId}/events/${eventId}/typos?${byEvent ? 'byEvent=true' : ''}`,
      transformResponse: response => response.data?.typos || [],
      providesTags: ['TYPO'],
    }),
  }),
})

export const { useGetTyposQuery } = typoApi
